import "core-js/es6";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

const targetScript = process.env.ADOBE_TARGET_SCRIPT;
if (targetScript) {
  const script = document.createElement("script");
  script.src = targetScript;
  script.async = true;
  document.head.appendChild(script);
}

ReactDOM.render(<App />, document.getElementById("comptix-app"));
